import AvatarSvg from './Avatar.svg';
import styles from './LogIn.module.css';

function LogIn({ handleLogIn }) {
    return (
      <button className={styles.layout} onClick={handleLogIn}>
        <img src={AvatarSvg} alt="Avatar" className={styles.icon} />
        <p className={styles.username}>login / sign up</p>
      </button>
    );
}

export default LogIn;